import React from 'react';
import {TableCell, withStyles} from '@material-ui/core';
import {styles, Classes} from './styles';
import {IFeedback} from './type';
import FeedbacksEditor from 'feedback-system/components/feedbacks-editor';

const Feedback = (props: IFeedback & Classes) => {
    const {name, author, team, rating, comment, classes} = props;

    return (
        <>
            <TableCell className={classes.TableCell}>{author}</TableCell>
            <TableCell className={classes.TableCell}>{name}</TableCell>
            <TableCell className={classes.TableCell}>{team}</TableCell>
            <TableCell
                className={classes.TableCell}
                style={{
                    padding: '0 8px'
                }}>
                <span>{rating}</span>
            </TableCell>
            <TableCell className={classes.TableCell}>
                <div className={classes.editorWrapper}>
                    <FeedbacksEditor feedback={comment} />
                </div>
            </TableCell>
        </>
    );
};

export default withStyles(styles)(React.memo(Feedback));
